import React from 'react';
import { AssignProfilePersonModalProps } from './types';
import styles from './AssignProfilePersonModal.module.scss';
import { Button, Card, CardContent, Grid, Modal, Typography } from '@mui/material';
import { useAssignProfilePersonModal } from './useAssignProfilePersonModal';
import ButtonDropDown from '../button-drop-down/ButtonDropDown';
import { useTranslation } from 'react-i18next';

const AssignProfilePersonModal = ({
  onClose,
  //primaryAction,
  open,
  modalMessage,
  goBackButtonText,
  secondaryAction,
  document,
  assignee,
  setAssignee,
  category,
  modalTitle,
  headerVariant,
  //signOriginalDocument,
}: AssignProfilePersonModalProps) => {
  const {
    selectedSupplier,
    setSelectedSupplier,
    getProfileNames,
    getSupplierOptions,
    getSupplierContactOptions,
    checkProfilePersonsAvailability,
    setAssignee: setSigningAssignee,
  } = useAssignProfilePersonModal(category, document);
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setSigningAssignee('');
        setSelectedSupplier('');
      }}
      closeAfterTransition
      className='action-modal'
    >
      <Grid container className={styles.modal_container}>
        <Grid size={{ xs: 11, md: 6, lg: 5 }}>
          <Card>
            <CardContent sx={{ paddingBottom: '16px !important' }}>
              {modalTitle && (
                <Typography variant={headerVariant ? headerVariant : 'h6'} gutterBottom>
                  {modalTitle}
                </Typography>
              )}
              {(document.customers?.length ?? 0) === 0 &&
                (document.employees?.length ?? 0) === 0 &&
                (document.suppliers?.length ?? 0) === 0 &&
                (document.business_profile_contacts?.length ?? 0) === 0 &&
                checkProfilePersonsAvailability(document.category ?? '') && (
                  <>
                    {modalMessage && <Typography>{modalMessage}</Typography>}
                    {category === 'suppliers' ? (
                      <>
                        <Grid component='div' container style={{ gap: '2%' }}>
                          <Grid component='div' style={{ width: '49%', marginTop: '16px' }}>
                            <ButtonDropDown
                              id='assignProfilePersonModalSelectSupplierDropdown'
                              value={selectedSupplier}
                              label={t('labels.selectSupplier')}
                              onChange={(event) => setSelectedSupplier(event.target.value)}
                              options={[
                                { value: 'noSupplier', label: t('labels.noSupplier') },
                                ...getSupplierOptions(),
                              ]}
                              placeholder={t('labels.chooseSupplier')}
                              disabled={!category || getSupplierOptions().length === 0}
                            />
                          </Grid>
                          {getSupplierContactOptions(selectedSupplier).length > 0 && (
                            <Grid component='div' style={{ width: '49%', marginTop: '16px' }}>
                              <ButtonDropDown
                                id='assignProfilePersonModalAssignToDropdown'
                                label={t('labels.assignTo')}
                                value={assignee}
                                onChange={(event) => setAssignee(event.target.value)}
                                options={[
                                  { value: 'noAssignee', label: t('labels.noAssignee') },
                                  ...getSupplierContactOptions(selectedSupplier),
                                ]}
                                placeholder={t('labels.assignTo')}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </>
                    ) : (
                      <Grid
                        component='div'
                        style={{ flexGrow: 1, width: '50%', marginTop: '16px' }}
                      >
                        <ButtonDropDown
                          id='assignProfilePersonModalAssignToDropdown2'
                          label={t('labels.assignTo')}
                          value={assignee}
                          onChange={(event) => setAssignee(event.target.value)}
                          options={[
                            { value: 'noAssignee', label: t('labels.noAssignee') },
                            ...(getProfileNames() ?? []),
                          ]}
                          placeholder={t('labels.chooseAssignee')}
                          disabled={!category || (getProfileNames()?.length ?? 0) === 0}
                        />
                      </Grid>
                    )}
                  </>
                )}
              <Grid
                component='div'
                container
                style={{
                  justifyContent: 'flex-end',
                  gap: '8px',
                  flexWrap: 'wrap',
                  marginTop: '16px',
                }}
              >
                <Button
                  id='assignProfilePersonModalCloseBtn'
                  variant='contained'
                  onClick={() => {
                    onClose();
                    setSigningAssignee('');
                    setSelectedSupplier('');
                  }}
                  className={'btn-default btn-action-basic btn-cancel'}
                >
                  {goBackButtonText}
                </Button>
                <Button
                  id='assignProfilePersonModalSignBtn'
                  variant='contained'
                  onClick={
                    /*'document_upload_html' in document &&
                    (document.document_upload_html?.length ?? 0) > 0 &&
                    !signOriginalDocument
                      ? primaryAction
                      :*/ secondaryAction
                  }
                  className='btn-default btn-action-basic'
                >
                  {t('buttons.sign')}
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Modal>
  );
};

export { AssignProfilePersonModal };
